/* __next_internal_client_entry_do_not_use__ USER_TEMPLATE_KEY,useUserCreate auto */import { create } from "zustand";
import { immer } from "zustand/middleware/immer";
import handler from "./handler";
export const USER_TEMPLATE_KEY = "UTKToken";
const userState =
// localAESStorage.getItem(USER_TEMPLATE_KEY) ||
{
  // email: '1184359500@qq.com',
  // googleId: '',
  // introduce: 'lllala',
  // loginType: 2,
  userId: " "
};
export const useUserCreate = create(immer(set => ({
  userState,
  dispatch: action => {
    const {
      type,
      payload
    } = action;
    set(state => {
      handler[type](state, payload);
    });
  }
})));